import { UIView, useRouter } from "@uirouter/react";
import { StickyStatesPlugin } from "@uirouter/sticky-states";
import { last } from "lodash";
import React from "react";
import { Option } from "space-monad";
import {
  ModalProps as PureComponentProps,
  Modal as PureComponent,
} from "../../components/overlay";
import { DashboardRoutes } from "../dashboard/routes";

export type ModalProps = Omit<PureComponentProps, "title" | "children">;

export const Modal = React.forwardRef<HTMLDivElement, ModalProps>(
  (props, ref) => {
    const router = useRouter();

    return (
      <PureComponent
        {...props}
        title={<UIView name="title" />}
        children={<UIView />}
        onDismiss={() => {
          const stickyStatesPlugin = router.getPlugin(
            "sticky-states"
          ) as unknown as StickyStatesPlugin;

          router.stateService.go(
            Option(last(stickyStatesPlugin.inactives()))
              .map((route) => route.name)
              .getOrElse(DashboardRoutes.name)
          );
        }}
      />
    );
  }
);
